<div class="promotion-code-child-component">
  <h5> {{ promotionOption === 'free-spin' ? 'Promotion Provider' : 'Promotion Type' }}</h5>
  <div class="promotion-code-child-component-content">
    <div class="row">
      <ng-container *ngIf="promotionOption === 'free-spin'">
        <!-- <div class="col-4" *ngFor="let type of promotionTypes.filter(t => t.value === 'Free Spin'); let i = index;">
          <div class="selection-button" [class.active]="type.value === selectedType" [class.disabled]="isEditMode" (click)="!isEditMode && onSelect(type.value)">
            <div class="col-10 pr-0">
              <p>{{ type.title }}</p>
              <p>{{ type.description }}</p>
            </div>
            <div class="col-2">
              <div class="selection-button-dot"></div>
            </div>
          </div>
        </div> -->
      </ng-container>
      <ng-container *ngIf="promotionOption === 'provider-promotion'">
        <div class="col-4" *ngFor="let type of promotionTypes;let i = index;">
          <div *ngIf="i < 2" class="selection-button"  [class.active]="type.value === selectedType" [class.disabled]="isEditMode" (click)="!isEditMode && onSelect(type.value)">
            <div class="col-10 pr-0">
              <p>{{ type.title }}</p>
              <p>{{ type.description }}</p>
            </div>
            <div class="col-2">
              <div class="selection-button-dot"></div>
            </div>
          </div>
        </div>
       </ng-container>
    </div>
  </div>
</div>